import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className={`footer-container1 ${props.rootClassName} `}>
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand-column footer-column">
              <div className="footer-logo-wrapper">
                <img
                  alt={props.imageAlt1}
                  src={props.imageSrc1}
                  className="footer-image"
                />
                <span className="footer-thq-footer-brand-name-elm footer-brand-name">
                  GESVET
                </span>
              </div>
              <p className="section-content footer-description">
                Digitalizando el trabajo en la manga. Una solución integral
                desarrollada por veterinarios para optimizar la gestión ganadera
                en el campo, con o sin conectividad.
              </p>
              <div className="footer-social-links">
                <Link to="/">
                  <div
                    aria-label="Facebook"
                    className="footer-thq-footer-social-icon-elm1 footer-social-icon"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </Link>
                <Link to="/">
                  <div
                    aria-label="Instagram"
                    className="footer-thq-footer-social-icon-elm2 footer-social-icon"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                          width="20"
                          height="20"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </Link>
                <a href="https://wa.me/2494241871">
                  <div aria-label="WhatsApp" className="footer-social-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m3 21l1.65-3.8a9 9 0 1 1 3.4 2.9z"></path>
                        <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0za5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h2 className="section-subtitle footer-column-title">Explorar</h2>
              <ul className="footer-links-list">
                <li className="footer-link-item">
                  <Link to="/">
                    <div className="footer-thq-footer-link-elm1 footer-link">
                      <span>Home</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/aplicacion">
                    <div className="footer-thq-footer-link-elm2 footer-link">
                      <span>Aplicacion</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/bluetooth">
                    <div className="footer-thq-footer-link-elm3 footer-link">
                      <span>Bluetooth</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/soporte">
                    <div className="footer-thq-footer-link-elm4 footer-link">
                      <span>Soporte</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h2 className="section-subtitle footer-column-title">Contacto</h2>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span className="section-content">249 424-1871</span>
                </div>
                <div className="footer-contact-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle r="3" cx="12" cy="10"></circle>
                    </g>
                  </svg>
                  <span className="section-content">
                    Tandil, Buenos Aires, Argentina
                  </span>
                </div>
                <div className="footer-cta-wrapper">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.exeo.gesvet"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="footer-thq-btn-elm btn-sm btn btn-primary footer-download-btn">
                      <span>Descargar App</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-legal">
              <p className="section-content footer-copyright">
                © 2026 GESVET. Todos los derechos reservados.
              </p>
              <div className="footer-legal-links">
                <Link to="/">
                  <div className="footer-thq-footer-legal-link-elm1 footer-legal-link">
                    <span>Privacidad</span>
                  </div>
                </Link>
                <Link to="/">
                  <div className="footer-thq-footer-legal-link-elm2 footer-legal-link">
                    <span>Términos</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-interactivity">
(function(){
  // No complex logic needed for this static footer,
  // but we can add a simple scroll-to-top behavior for the links if they were internal
  // or simple hover state logging for analytics in a real scenario.

  const footerLinks = document.querySelectorAll(".footer-link")

  footerLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      // Intentional subtle feedback could go here
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <nav className="footer-thq-navlinks-elm">
        <Link to="/privacy">
          {props.text ?? (
            <Fragment>
              <span className="footer-text19">Soporte</span>
            </Fragment>
          )}
        </Link>
        <Link to="/aplicacion">
          {props.text1 ?? (
            <Fragment>
              <span className="footer-text17">Aplicacion</span>
            </Fragment>
          )}
        </Link>
        <Link to="/">
          {props.text2 ?? (
            <Fragment>
              <span className="footer-text18">Home</span>
            </Fragment>
          )}
        </Link>
        <Link to="/bluetooth">
          {props.text3 ?? (
            <Fragment>
              <span className="footer-text21">Bluetooth</span>
            </Fragment>
          )}
        </Link>
        <Link to="/soporte">
          {props.text4 ?? (
            <Fragment>
              <span className="footer-text20">Soporte1</span>
            </Fragment>
          )}
        </Link>
      </nav>
    </div>
  )
}

Footer.defaultProps = {
  imageAlt1: 'image',
  text1: undefined,
  text2: undefined,
  text: undefined,
  text4: undefined,
  rootClassName: '',
  text3: undefined,
  imageSrc1: '/icono-200h.png',
}

Footer.propTypes = {
  imageAlt1: PropTypes.string,
  text1: PropTypes.element,
  text2: PropTypes.element,
  text: PropTypes.element,
  text4: PropTypes.element,
  rootClassName: PropTypes.string,
  text3: PropTypes.element,
  imageSrc1: PropTypes.string,
}

export default Footer
